// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const Edit = createSvgIcon(
  { LeftToRight: <React.Fragment><g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"><path d="M8.9497 20L21.975 6.9749c1.3668-1.3668 1.3668-3.583 0-4.9497l-.0503-.0503c-1.3668-1.3668-3.5829-1.3668-4.9497 0L3.9497 15l5 5zM19.9498 9l-5-5M17.4498 6.5l-11 11" /><path d="M8.9498 20l-8 3 3-8 5 5z" /></g><defs></defs></React.Fragment>, },
  'default'
);
